import styled, { keyframes } from 'styled-components';

const LoadingKeyframes = keyframes`
  0%{
    stroke-dasharray:80;
    stroke-dashoffset:80
  }
  50%{
    stroke-dasharray:80;
    stroke-dashoffset:0
  }
  100%{
    stroke-dasharray:80;
    stroke-dashoffset:-80
  }
`;

const LoadingContainer = styled.svg`
  height: ${({ theme }) => theme.spacing['9Xl']};
  width: ${({ theme }) => theme.spacing['9Xl']};
  fill: none;

  .st0 {
    stroke: ${({ theme }) => theme.brand.tertiary};
    stroke-dasharray: 80;
    stroke-dashoffset: 80;
    animation: ${LoadingKeyframes} 3s infinite ease-in-out;
  }
  .st1 {
    stroke: ${({ theme }) => theme.brand.primary};
  }
`;

const LoadingAnimation = (props: { id?: string }) => (
  <LoadingContainer viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      strokeMiterlimit={10}
      strokeWidth={2.8}
      d='M9.6 17.62c-1.19-.03-2.38-.07-3.56-.14-1.64-.1-3.14-1.57-3.27-3.21-.21-3-.21-4.53 0-7.52.13-1.63 1.64-3.11 3.27-3.21 3.96-.22 7.97-.22 11.92 0 1.64.11 3.14 1.58 3.27 3.21.21 2.97.21 4.46.01 7.41-.12 1.6-1.53 3.04-3.15 3.21-.92.09-1.83.17-2.7.23-1.18.04-2.01.76-2.87 1.51-.87.77-1.72 1.51-2.91 1.51'
      className='st1'
    />
    <path
      className='st0'
      strokeMiterlimit={10}
      strokeWidth={3}
      d='M9.6 17.62c-1.19-.03-2.38-.07-3.56-.14-1.64-.1-3.14-1.57-3.27-3.21-.21-3-.21-4.53 0-7.52.13-1.63 1.64-3.11 3.27-3.21 3.96-.22 7.97-.22 11.92 0 1.64.11 3.14 1.58 3.27 3.21.21 2.97.21 4.46.01 7.41-.12 1.6-1.53 3.04-3.15 3.21-.92.09-1.83.17-2.7.23-1.18.04-2.01.76-2.87 1.51-.87.77-1.72 1.51-2.91 1.51'
    />
  </LoadingContainer>
);

export default LoadingAnimation;
